import {observable,action} from 'mobx'
import {getVal,setVal,deleteVal} from '../../utils/server'

class UserStore{
  @observable addUser = getVal("addUser",{
    "name": "",
    "sendType": "sms",
    "param": "",
    "userGroup": "",
  })

  @action setAddUser(addUser){
    this.addUser = addUser
    setVal("addUser",this.addUser)
  }

  @action deleteAddUser(){
    deleteVal("addUser")
  }
}

export default new UserStore()


// WEBPACK FOOTER //
// ./src/routes/Subscription/store.js